import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import duration from 'dayjs/plugin/duration';
import updateLocale from 'dayjs/plugin/updateLocale';
import relativeTime from 'dayjs/plugin/relativeTime'
// eslint-disable-next-line import/no-named-default
import { default as spanish } from 'dayjs/locale/es';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);
dayjs.extend(updateLocale);

dayjs.extend(relativeTime, { rounding: (n) => Math.round(n * 2) / 2 });

dayjs.tz.setDefault('America/Argentina/Buenos_Aires');
dayjs.locale('es', spanish);

export const $dayjs = dayjs

export default {
  install: Vue => {
    Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs })
  }
}
